import {
  SET_PIT_PLAN,
  SUPPORT_REQUEST_LOOKUP,
  CONFORMITY_DEPTS_LOOKUP,
  CONFORMITY_TYPE_LOOKUP,
  GET_LOOKUPS_SUCCEED,
  GET_ROM_LOOKUPS
} from 'fixtures/actions'

let initialState = {};
let initialStateArr = [];
let initialStateData = {data: {}};

export const effectivePitPlan = (state = initialState, action) => {
  switch (action.type) {
    case SET_PIT_PLAN:
      return { ...action.payload };
    default:
      return state;
  }
}

export const supportRequestLookup = (state = initialStateArr, action) => {
  switch (action.type) {
    case SUPPORT_REQUEST_LOOKUP:
      return [...action.payload];
    default:
      return state;
  }
}

export const conformityReportLookup = (state = initialState, action) => {
  switch (action.type) {
    case CONFORMITY_TYPE_LOOKUP:
      return { ...state, types: [...action.payload] };
    case CONFORMITY_DEPTS_LOOKUP:
      return { ...state, depts: [...action.payload] };
    default:
      return state;
  }
}

export const lookups = (state = initialStateData, action) => {
  switch (action.type) {
    case GET_LOOKUPS_SUCCEED:
      const { data, lookupType, lookupSubType } = action
      if (lookupType) {
        if (!state.data[lookupType]) state.data[lookupType] = {}
        if (lookupSubType) state.data[lookupType][lookupSubType] = data
      }

      return {
        ...state,
      }
    default:
      return state;
  }
}

export const romLookups = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROM_LOOKUPS:
      return { ...action.payload };
    default:
      return state;
  }
}